/**
 * In the event that an API returns the property names in a malformed or undesired fashion, this method can update according to a matching expression.
 *
 * Ex:
 * const original = { UID: "1234-ABCD", nested: { UID: "5678-EFGH" } }
 *
 * updateFieldNames(original, /UID/, "uid")
 *   => { uid: "1234-ABCD", nested: { uid: "5678-EFGH" } }
 *
 * @param obj The object to update.
 * @param matchingRegex The regular expression to match with.
 * @param replacement The replacement property name.
 */
export function updateFieldNames<T>(obj: T, matchingRegex: RegExp, replacement: string): T {
  for (const key of Object.keys(obj)) {
    if (typeof (obj)[key as keyof T] === "object") {
      (obj)[key as keyof T] = updateFieldNames((obj)[key as keyof T], matchingRegex, replacement);
    }

    if (matchingRegex.test(key)) {
      const value = (obj)[key as keyof T];
      delete (obj)[key as keyof T];
      (obj)[replacement as keyof T] = value;
    }
  }

  return obj;
}
